import { render, staticRenderFns } from "./openClassList.vue?vue&type=template&id=91c5d848&scoped=true"
import script from "./openClassList.vue?vue&type=script&lang=js"
export * from "./openClassList.vue?vue&type=script&lang=js"
import style0 from "./openClassList.vue?vue&type=style&index=0&id=91c5d848&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c5d848",
  null
  
)

export default component.exports